
import Vue from "vue";

interface LangItem {
  icon: any;
  text: string;
  value: string;
}

export default Vue.extend({
  name: "LangSwitcher",

  props: {
    hideFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    show: false as boolean,
    items: [
      {
        icon: require("@/assets/images/locales/ru.svg"),
        text: "Русский",
        value: "ru",
      },
      {
        icon: require("@/assets/images/locales/en.svg"),
        text: "English",
        value: "en",
      },
      {
        icon: require("@/assets/images/locales/ro.svg"),
        text: "Română",
        value: "ro",
      },
    ] as Array<LangItem>,
  }),

  computed: {
    lang: {
      set({ value }: LangItem) {
        (this as any).$store.dispatch("localization/set", value);
        const currentUrl = location.href.split("/");
        const langPosition = 3;

        currentUrl[langPosition] = value;
        location.href = currentUrl.join("/");
      },
      get(): string {
        return (this as any).$store.getters["localization/getCurrent"];
      },
    },
    icon() {
      return this.items.find((item) => item.value === this.lang)?.icon;
    },
  },

  methods: {
    toggle(): void {
      this.show = !this.show;
    },
  },
});
